import PageHeader from "app/shared/PageHeader";
import React, { useState } from "react";
import {Tabs} from "antd";


function WatchTower() {
   const [activeTab, setActiveTab] = useState("1");
   const items = [
       {
         key: "1",
         label: "Dept CSM",
       },
       {
        key: "2",
        label: "Dept CSM - Receivable",
      },
       {
         key: "3",
         label: "Dept OPS",
       },
       {
         key: "4",
         label: "Dept DA",
       },
     
       {
         key: "5",
         label: "Dept SALES",
       },
       {
        key:"6",
        label:"Dept HR"
       }
     ];


   const zaLinks = {
     "1": "https://analytics.zoho.in/open-view/103074000048779368/309b59721deec109bde2822548f9b971e8af3dff6335f6942172b8dc8d2991a1", // Dept CSM
     "2": "https://analytics.zoho.com/open-view/1498508000021189567/364b810351d40190ebd48dce614883a1",
     "3": "https://analytics.zoho.in/open-view/103074000048779859/45ab0e0f8e925e35d9e3cf3e85d19c1ac243dd4c2a7ef7c5f8e91d9e8ca863a0", // Dept OPS
     "4": "https://analytics.zoho.in/open-view/103074000048803545/0aae7aa0f9173c64cea625d52fe37e88567a8151b13d32b12905fafee5f1c3f4", // Dept DA
     "5": "https://analytics.zoho.com/open-view/1498508000021104054/8ff832ebde75d64724f70a4a711eb171cbd207182f2d1bb06f12023d6086d1af", // Dept SALES
     "6":"https://analytics.zoho.com/open-view/1498508000021302851/92b59e5342ae95b020749b6e1b50901f2dd264cb580b35fcfbb6f45e0be7da6e"
   };


 return (
   <div style={{height:'100%'}}>
       <PageHeader
       leftActions={
           <Tabs
             items={items}
             tabBarStyle={{
               borderBottom: "none",
               margin: 0,
             }}
             activeKey={activeTab}
             onChange={(tabItem: string) => setActiveTab(tabItem)}
           />
         }
         showWorkspaceDropdown={false}
       />
       <iframe
         height="100%"
         style={{ width: "100%" }}
         scrolling="no"
         title="Iframe"
         id="dashboardFrame"
         src={zaLinks[activeTab as keyof typeof zaLinks]}
       ></iframe>
   </div>
 );
}


export default WatchTower;





